export default {
    url: '/detail/:id',
    template: '<forms-validations-detail progress="vm.progress"/>',
    resolve: {
        progress (TrainingProgressResource, $stateParams) {
            return TrainingProgressResource.get({
                id: $stateParams.id,
                expand: 'user,occurrence.course.activeI18n,formSubmission.formSubmissionAnswers,occurrenceTraining.training.activeI18n,' +
                'formSubmission.formSubmissionAnswers.answer,formSubmission.formSubmissionAnswers.question.activeI18n,' +
                'formSubmission.formSubmissionAnswers.question.category.activeI18n,' +
                'formSubmission.formSubmissionAnswers.question.questionAnswers'
            }).$promise;
        }
    },
    controller (progress) {
        this.progress = progress;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/validations/detail/index.js